
import React from 'react';
import { Star } from 'lucide-react';

interface TestimonialProps {
  quote: string;
  author: string;
  stars: number;
  type: string;
}

const Testimonial = ({ quote, author, stars, type }: TestimonialProps) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
      <div className="flex mb-3">
        {[...Array(5)].map((_, i) => (
          <Star 
            key={i} 
            className={`w-5 h-5 ${i < stars ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'} mr-1`} 
          />
        ))}
      </div>
      <p className="text-gray-700 italic mb-4">"{quote}"</p>
      <div>
        <p className="font-semibold">{author}</p>
        <p className="text-sm text-gray-500">{type}</p>
      </div>
    </div>
  );
};

const ChildrenTestimonials = () => {
  const testimonials = [
    {
      quote: "Oscar har en helt speciel evne til at engagere børn i musik. Min datter glæder sig til hver eneste klavertime og øver frivilligt derhjemme, hvilket jeg aldrig havde troet var muligt.",
      author: "Maria Jørgensen",
      stars: 5,
      type: "Mor til pige på 8 år"
    },
    {
      quote: "Min søn er meget energisk og har svært ved at koncentrere sig i længere tid, men Oscar formår at holde ham fokuseret gennem hele timen med kreative og sjove øvelser. Vi ser stor fremgang.",
      author: "Kasper Hansen",
      stars: 5,
      type: "Far til dreng på 7 år"
    },
    {
      quote: "Efter at have prøvet to andre klaverlærere, fandt vi endelig Oscar. Hans tålmodighed og evne til at motivere har gjort en enorm forskel for min datters indstilling til klaverspil.",
      author: "Louise Petersen",
      stars: 5,
      type: "Mor til teenager på 13 år"
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-serif font-bold mb-4">
            Hvad forældre siger
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Hør fra andre forældre, der har oplevet hvordan deres børn blomstrer gennem min klaverundervisning.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <Testimonial 
              key={index}
              quote={testimonial.quote}
              author={testimonial.author}
              stars={testimonial.stars}
              type={testimonial.type}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ChildrenTestimonials;
